import { schema } from 'normalizr';
import documentFolderVariant from './documentFolderVariant';
import labelSchema from './label';

const documentFolderSchema = new schema.Entity('documentFolders', {
  variants: [documentFolderVariant],
  defaultVariant: documentFolderVariant,
  targets: [labelSchema],
});

export default documentFolderSchema;
